module.exports = __webpack_public_path__ + "img/wait.fbe7a053.svg";